/**
 * Agreement Server
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { ErrorModel } from '../model/errorModel';
// @ts-ignore
import { PublicLink } from '../model/publicLink';
// @ts-ignore
import { ResponseMessage } from '../model/responseMessage';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    PublicLinkServiceInterface
} from './publicLink.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class PublicLinkService extends BaseService implements PublicLinkServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Create new job using existing public link and send sign request to recipients
     * @param code Code of the public link
     * @param recipient1Name Name of the first recipient
     * @param recipient1Email Email of the first recipient
     * @param recipient1CitizenId CitizenId of the first recipient
     * @param recipient2Name Name of the second recipient
     * @param recipient2Email Email of the second recipient
     * @param recipient2CitizenId CitizenId of the second recipient
     * @param recipient3Name Name of the third recipient
     * @param recipient3Email Email of the third recipient
     * @param recipient3CitizenId CitizenId of the third recipient
     * @param recipient4Name Name of the fourth recipient
     * @param recipient4Email Email of the fourth recipient
     * @param recipient4CitizenId CitizenId of the fourth recipient
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public jobsPublicLinkCodePost(code: string, recipient1Name: string, recipient1Email: string, recipient1CitizenId?: string, recipient2Name?: string, recipient2Email?: string, recipient2CitizenId?: string, recipient3Name?: string, recipient3Email?: string, recipient3CitizenId?: string, recipient4Name?: string, recipient4Email?: string, recipient4CitizenId?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ResponseMessage>;
    public jobsPublicLinkCodePost(code: string, recipient1Name: string, recipient1Email: string, recipient1CitizenId?: string, recipient2Name?: string, recipient2Email?: string, recipient2CitizenId?: string, recipient3Name?: string, recipient3Email?: string, recipient3CitizenId?: string, recipient4Name?: string, recipient4Email?: string, recipient4CitizenId?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ResponseMessage>>;
    public jobsPublicLinkCodePost(code: string, recipient1Name: string, recipient1Email: string, recipient1CitizenId?: string, recipient2Name?: string, recipient2Email?: string, recipient2CitizenId?: string, recipient3Name?: string, recipient3Email?: string, recipient3CitizenId?: string, recipient4Name?: string, recipient4Email?: string, recipient4CitizenId?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ResponseMessage>>;
    public jobsPublicLinkCodePost(code: string, recipient1Name: string, recipient1Email: string, recipient1CitizenId?: string, recipient2Name?: string, recipient2Email?: string, recipient2CitizenId?: string, recipient3Name?: string, recipient3Email?: string, recipient3CitizenId?: string, recipient4Name?: string, recipient4Email?: string, recipient4CitizenId?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (code === null || code === undefined) {
            throw new Error('Required parameter code was null or undefined when calling jobsPublicLinkCodePost.');
        }
        if (recipient1Name === null || recipient1Name === undefined) {
            throw new Error('Required parameter recipient1Name was null or undefined when calling jobsPublicLinkCodePost.');
        }
        if (recipient1Email === null || recipient1Email === undefined) {
            throw new Error('Required parameter recipient1Email was null or undefined when calling jobsPublicLinkCodePost.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/x-www-form-urlencoded'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let localVarFormParams: { append(param: string, value: any): any; };
        let localVarUseForm = false;
        let localVarConvertFormParamsToString = false;
        if (localVarUseForm) {
            localVarFormParams = new FormData();
        } else {
            localVarFormParams = new HttpParams({encoder: this.encoder});
        }

        if (recipient1Name !== undefined && recipient1Name !== null) {
            localVarFormParams = localVarFormParams.append('recipient1Name', <any>recipient1Name) as any || localVarFormParams;
        }
        if (recipient1Email !== undefined && recipient1Email !== null) {
            localVarFormParams = localVarFormParams.append('recipient1Email', <any>recipient1Email) as any || localVarFormParams;
        }
        if (recipient1CitizenId !== undefined && recipient1CitizenId !== null) {
            localVarFormParams = localVarFormParams.append('recipient1CitizenId', <any>recipient1CitizenId) as any || localVarFormParams;
        }
        if (recipient2Name !== undefined && recipient2Name !== null) {
            localVarFormParams = localVarFormParams.append('recipient2Name', <any>recipient2Name) as any || localVarFormParams;
        }
        if (recipient2Email !== undefined && recipient2Email !== null) {
            localVarFormParams = localVarFormParams.append('recipient2Email', <any>recipient2Email) as any || localVarFormParams;
        }
        if (recipient2CitizenId !== undefined && recipient2CitizenId !== null) {
            localVarFormParams = localVarFormParams.append('recipient2CitizenId', <any>recipient2CitizenId) as any || localVarFormParams;
        }
        if (recipient3Name !== undefined && recipient3Name !== null) {
            localVarFormParams = localVarFormParams.append('recipient3Name', <any>recipient3Name) as any || localVarFormParams;
        }
        if (recipient3Email !== undefined && recipient3Email !== null) {
            localVarFormParams = localVarFormParams.append('recipient3Email', <any>recipient3Email) as any || localVarFormParams;
        }
        if (recipient3CitizenId !== undefined && recipient3CitizenId !== null) {
            localVarFormParams = localVarFormParams.append('recipient3CitizenId', <any>recipient3CitizenId) as any || localVarFormParams;
        }
        if (recipient4Name !== undefined && recipient4Name !== null) {
            localVarFormParams = localVarFormParams.append('recipient4Name', <any>recipient4Name) as any || localVarFormParams;
        }
        if (recipient4Email !== undefined && recipient4Email !== null) {
            localVarFormParams = localVarFormParams.append('recipient4Email', <any>recipient4Email) as any || localVarFormParams;
        }
        if (recipient4CitizenId !== undefined && recipient4CitizenId !== null) {
            localVarFormParams = localVarFormParams.append('recipient4CitizenId', <any>recipient4CitizenId) as any || localVarFormParams;
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/jobs/public_link/${this.configuration.encodeParam({name: "code", value: code, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ResponseMessage>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get public link using code
     * @param code Code of public link
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public publicLinkCodeGet(code: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PublicLink>;
    public publicLinkCodeGet(code: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PublicLink>>;
    public publicLinkCodeGet(code: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PublicLink>>;
    public publicLinkCodeGet(code: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (code === null || code === undefined) {
            throw new Error('Required parameter code was null or undefined when calling publicLinkCodeGet.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/public_link/${this.configuration.encodeParam({name: "code", value: code, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PublicLink>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create new public link using existing job template for the user
     * @param accessToken System access token
     * @param templateId ID of the job template
     * @param recipient1Id ID of the first recipient
     * @param recipient1Nick Nickname of the first recipient
     * @param description description
     * @param recipient2Id ID of the second recipient
     * @param recipient2Nick Nickname of the second recipient
     * @param recipient3Id ID of the third recipient
     * @param recipient3Nick Nickname of the third recipient
     * @param recipient4Id ID of the fourth recipient
     * @param recipient4Nick Nickname of the fourth recipient
     * @param returnUrl redirect url after user enter recipient infos
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public publicLinkPost(accessToken: string, templateId: string, recipient1Id: string, recipient1Nick: string, description?: string, recipient2Id?: string, recipient2Nick?: string, recipient3Id?: string, recipient3Nick?: string, recipient4Id?: string, recipient4Nick?: string, returnUrl?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PublicLink>;
    public publicLinkPost(accessToken: string, templateId: string, recipient1Id: string, recipient1Nick: string, description?: string, recipient2Id?: string, recipient2Nick?: string, recipient3Id?: string, recipient3Nick?: string, recipient4Id?: string, recipient4Nick?: string, returnUrl?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PublicLink>>;
    public publicLinkPost(accessToken: string, templateId: string, recipient1Id: string, recipient1Nick: string, description?: string, recipient2Id?: string, recipient2Nick?: string, recipient3Id?: string, recipient3Nick?: string, recipient4Id?: string, recipient4Nick?: string, returnUrl?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PublicLink>>;
    public publicLinkPost(accessToken: string, templateId: string, recipient1Id: string, recipient1Nick: string, description?: string, recipient2Id?: string, recipient2Nick?: string, recipient3Id?: string, recipient3Nick?: string, recipient4Id?: string, recipient4Nick?: string, returnUrl?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling publicLinkPost.');
        }
        if (templateId === null || templateId === undefined) {
            throw new Error('Required parameter templateId was null or undefined when calling publicLinkPost.');
        }
        if (recipient1Id === null || recipient1Id === undefined) {
            throw new Error('Required parameter recipient1Id was null or undefined when calling publicLinkPost.');
        }
        if (recipient1Nick === null || recipient1Nick === undefined) {
            throw new Error('Required parameter recipient1Nick was null or undefined when calling publicLinkPost.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/x-www-form-urlencoded'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let localVarFormParams: { append(param: string, value: any): any; };
        let localVarUseForm = false;
        let localVarConvertFormParamsToString = false;
        if (localVarUseForm) {
            localVarFormParams = new FormData();
        } else {
            localVarFormParams = new HttpParams({encoder: this.encoder});
        }

        if (templateId !== undefined && templateId !== null) {
            localVarFormParams = localVarFormParams.append('template_id', <any>templateId) as any || localVarFormParams;
        }
        if (description !== undefined && description !== null) {
            localVarFormParams = localVarFormParams.append('description', <any>description) as any || localVarFormParams;
        }
        if (recipient1Id !== undefined && recipient1Id !== null) {
            localVarFormParams = localVarFormParams.append('recipient1Id', <any>recipient1Id) as any || localVarFormParams;
        }
        if (recipient1Nick !== undefined && recipient1Nick !== null) {
            localVarFormParams = localVarFormParams.append('recipient1Nick', <any>recipient1Nick) as any || localVarFormParams;
        }
        if (recipient2Id !== undefined && recipient2Id !== null) {
            localVarFormParams = localVarFormParams.append('recipient2Id', <any>recipient2Id) as any || localVarFormParams;
        }
        if (recipient2Nick !== undefined && recipient2Nick !== null) {
            localVarFormParams = localVarFormParams.append('recipient2Nick', <any>recipient2Nick) as any || localVarFormParams;
        }
        if (recipient3Id !== undefined && recipient3Id !== null) {
            localVarFormParams = localVarFormParams.append('recipient3Id', <any>recipient3Id) as any || localVarFormParams;
        }
        if (recipient3Nick !== undefined && recipient3Nick !== null) {
            localVarFormParams = localVarFormParams.append('recipient3Nick', <any>recipient3Nick) as any || localVarFormParams;
        }
        if (recipient4Id !== undefined && recipient4Id !== null) {
            localVarFormParams = localVarFormParams.append('recipient4Id', <any>recipient4Id) as any || localVarFormParams;
        }
        if (recipient4Nick !== undefined && recipient4Nick !== null) {
            localVarFormParams = localVarFormParams.append('recipient4Nick', <any>recipient4Nick) as any || localVarFormParams;
        }
        if (returnUrl !== undefined && returnUrl !== null) {
            localVarFormParams = localVarFormParams.append('returnUrl', <any>returnUrl) as any || localVarFormParams;
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/public_link`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PublicLink>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
